import React, {useEffect} from 'react';
import {useIntl} from 'react-intl';
import {useParams, useLocation, useHistory, generatePath} from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SigningTabLayout from '../components/SigningTabLayout';
import {DOCUSIGN_EVENT} from '../constants/renewalClick';
import {reportToRenewalTab} from '../utils/signingTab';
import {RenewalClickRoute} from '../../../config/routes';

// DocuSign redirects the signing tab here. Report the outcome and close.
const SigningReturnScreen = () => {
  const intl = useIntl();
  const {shortLinkKey} = useParams();
  const {search} = useLocation();
  const history = useHistory();
  const docusignEvent = new URLSearchParams(search).get('event');
  const signed = docusignEvent === DOCUSIGN_EVENT.SIGNING_COMPLETE;

  useEffect(() => {
    if (!reportToRenewalTab(shortLinkKey, docusignEvent)) {
      // Opened without a renewal tab to return to — continue the flow here.
      history.replace(generatePath(RenewalClickRoute.pathname, {shortLinkKey}));
    }
  }, [shortLinkKey, docusignEvent, history]);

  return (
    <SigningTabLayout
      icon={signed
        ? <CheckCircleOutlineIcon sx={{fontSize: 56, color: 'primary.main'}} />
        : <ErrorOutlineIcon sx={{fontSize: 56, color: 'text.secondary'}} />}
      title={intl.formatMessage({id: signed ? 'renewalClick.signing.returnTitle' : 'renewalClick.signing.returnFailedTitle'})}
      description={intl.formatMessage({id: 'renewalClick.signing.returnDescription'})}
    />
  );
};

export default SigningReturnScreen;
